export default import.meta.ROLLDOWN_FILE_URL_k9l9Bb5LQ1cIcbBEU6U7rQ